export type SharingScope = 'personal' | 'organization';

export const SHARING_SCOPES: readonly SharingScope[] = ['personal', 'organization'];

export const SHARING_SCOPE_LABELS: Record<SharingScope, string> = {
  personal: 'Personal',
  organization: 'Organization',
};

export const DEFAULT_SHARING_SCOPE: SharingScope = 'personal';
